import { first } from 'lodash'
import { Translate } from 'ol/interaction'
import { TranslateEvent } from 'ol/interaction/Translate'
import { Layer } from 'ol/layer'
import { toLonLat } from 'ol/proj'
import { useCallback, useEffect, useState } from 'react'

import { useMap } from '../useMap'

type UseTranslateProps = {
  layer: Layer
  onTranslated?: (p: {
    id: string | number
    coords: {
      lng: number
      lat: number
    }
  }) => void
}

type UseTranslate = void

export function useTranslate(props: UseTranslateProps): UseTranslate {
  const { layer, onTranslated } = props

  const [translate] = useState(
    new Translate({
      layers: [layer],
    }),
  )

  useEffect(() => {
    console.log('onTranslated has changed, set active', {
      onTranslated,
      active: !!onTranslated,
    })
    translate.setActive(!!onTranslated)
  }, [onTranslated])

  const onTranslateEnd = useCallback(
    (e: TranslateEvent) => {
      try {
        const feature = first(e.features.getArray())

        if (!feature) {
          return
        }

        const id = feature.get('id')

        const coords = toLonLat(e.coordinate)

        if (!onTranslated) return
        onTranslated({
          id,
          coords: {
            lng: coords[0],
            lat: coords[1],
          },
        })
      } catch (err) {
        //
      }
    },
    [onTranslated],
  )

  useEffect(() => {
    translate.on('translateend', onTranslateEnd)

    return () => {
      translate.un('translateend', onTranslateEnd)
    }
  }, [onTranslateEnd])

  const { map } = useMap()

  useEffect(() => {
    map.addInteraction(translate)
    return () => {
      map.removeInteraction(translate)
    }
  }, [map, translate])

  return
}
